import { useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import {
  getTicketDestinationBy,
  getTicketUrl as getTicketUrlApi,
} from "@/api/ticket";
import { useLoadingStore } from "@/stores/loading";
import MessageList from "@/components/MessageList";
import MessageInputBox from "@/components/MessageInputBox";
import * as Config from "@/config";
import { TicketDestinations, Ticket as TicketType } from "@/types/ticket";

export default function Ticket() {
  const setLoading = useLoadingStore((state) => state.setLoading);
  const pathname = Config.BASE_URL + Config.BASENAME + useLocation().pathname;
  console.log(pathname);
  const [ticket, setTicket] = useState<TicketType>();
  const [ticketDestList, setTicketDestList] = useState<TicketDestinations[]>(
    []
  );

  const getTicketUrl = useCallback(() => {
    Promise.all([getTicketUrlApi(pathname), getTicketDestinationBy(3)])
      .then((result) => {
        setTicket(result[0].data);
        setTicketDestList(result[1].data.ticketDestinations);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    getTicketUrl();
  }, []);

  return (
    <div className="uk-flex uk-flex-column uk-flex-middle uk-margin-large-bottom">
      <div className="uk-width-3-4">
        <div className="individual-ticket-sub-header">
          <div className="stick"></div>
          <div>問い合わせ番号 {ticket?.control_no}</div>
        </div>
        <div className="uk-margin-small-top">
          <table className="uk-width-medium">
            <tbody>
              <tr>
                <td className="uk-width-2-5 background-gray239">ステータス</td>
                <td>{ticket?.status}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <MessageList ticket={ticket} className="uk-margin-top" />
        <MessageInputBox
          ticket={ticket}
          getTicketUrl={getTicketUrl}
          ticketDestList={ticketDestList}
        />
      </div>
    </div>
  );
}